export default "__VITE_ASSET__juseP7w5__"